export function removeBgUiSelector(state) {
  return state.ui.workspace.removeBg;
}
